export const getinput = (xins, data) => {
    // window.console.log('>>>',xins,data);
    let mods = [];
    let plnes = [];
    data.modulos.forEach(x => {
        mods.push({modulo:x.nombre,numero:parseInt(x.numero),sigla:'MOD',tipo:"NEW"})
    });
    data.plan.forEach(x=>{
        plnes.push({concepto_pago:x.concepto,fecha_pago:x.fecha,monto:parseInt(x.monto),nro_cuota:parseInt(x.numero)})
    })
    const r = {
        "ciudad": ""+data.ciudad_firma,
        "direccion": ""+data.unidad_domicilio,
        "inscripcion_id": xins.id,
        "modulos": mods,
        "participante": ""+data.participante,
        "participante_ci": ""+data.participante_cedula,
        "participante_domicilio": ""+data.participante_domicilio,
        "participante_id": xins.estudiante.id,
        "participante_nacionalidad": ""+data.participante_nacionalidad,
        "pdf": "string",
        "plan_pagos": plnes,
        "programa_carga_horario": 2400,
        "programa_colegiatura_contado": 15360,
        "programa_colegiatura_monto": 15360,
        "programa_matricula_monto": 0,
        "programa_monto": 15360,
        "programa_nombre": ""+data.programa,
        "programa_tipo": "Diplomado",
        "representante": ""+data.representacion,
        "representante_ci": ""+data.unidad_cedula,
        "representante_expedido": ""+data.unidad_cedula_expedida
    }
    return r;
}

export const getNumeroName = (num) =>{
    const writtenNumber = require('written-number');
    let str = writtenNumber(num, { lang: 'es' });
    return str;
}

export const getNumeroDeci = (numero) =>{
    let number = window.accounting.formatMoney(numero, '', 2, '.', ',');
    return number; 
}

export const getMesStr = (nummes) => {
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    return meses[nummes] || '';
}

export const getCategoriaName = (cate) =>{
    return (cate.nombre+'').toUpperCase();
}

export const getNacionalidad = (p) =>{
    if(!p) return ''
    if(p && p.nombre == 'Bolivia') return 'boliviana'
    if(p) return p.nombre;
    return '';
}

export const getProgramaTitulo = (cat) =>{
    const m = {
        'DIPLOMADO': 'el diplomado',
        'ESPECIALIDAD': 'la especialidad',
        'MAESTRIA': 'la maestría',
        'MAESTRÍA': 'la maestría',
    }
    return m[cat]
}

export const getCategoriaMaestrante = (cat) =>{
    const m = {
        'DIPLOMADO': 'DIPLOMANTE',
        'ESPECIALIDAD': 'POSGRADUANTE',
        'MAESTRIA': 'MAESTRANTE',
        'MAESTRÍA': 'MAESTRANTE',
    }
    return m[cat]
}

